import { render, staticRenderFns } from "./MtIndustrysModal.vue?vue&type=template&id=21487898&"
import script from "./MtIndustrysModal.vue?vue&type=script&lang=js&"
export * from "./MtIndustrysModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports